import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Observable} from 'rxjs';
import {ICruisePrefetch} from '../../../shared/interfaces/icruise-prefetch';
import * as dayjs from 'dayjs';
import {WidgetService} from '../../../shared/services/widget.service';
import {MobileService} from '../../../shared/services/mobile.service';

@Component({
  selector: 'app-engine-cruise-select-date',
  templateUrl: './engine-cruise-select-date.component.html',
  styleUrls: ['./engine-cruise-select-date.component.scss']
})
export class EngineCruiseSelectDateComponent implements OnInit, OnChanges {

  public isMobile$: Observable<boolean>;
  public isWidget$: Observable<boolean>;

  constructor(private _mobileService: MobileService,
              private _widgetService: WidgetService) { }

  @Output() selectedDate: EventEmitter<string> = new EventEmitter<string>();
  @Input() defaultDate: number | string;
  @Input() cruisePrefetch$: Observable<ICruisePrefetch>;
  selectedDateInner: any;

  ngOnInit(): void {
    this.isMobile$ = this._mobileService.isMobile();
    this.isWidget$ = this._widgetService.isWidget();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.defaultDate && this.defaultDate) {
      const defaultDateUnix = Number(this.defaultDate);
      this.selectedDateInner = dayjs(defaultDateUnix * 1000).format('MM-YYYY');
      this.selectedDate.emit(this.selectedDateInner);
    }
  }

  selectDate(date: any): void {
    this.selectedDateInner = date ? date.dateString : undefined;
    this.selectedDate.emit(this.selectedDateInner);
  }

}
